export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7505.20e9cd5e.jpg";